/* ============================================================
   Brooklyn Sneakers — brooklyn-cart.js
   Cart drawer state, Shopify Cart API sync, free-shipping bar,
   combo upsell, toast, scroll reveals.
   Syncs with /cart.js — never mutates DOM without updating Shopify.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.BrooklynConfig || {};
  var THRESHOLD = CFG.freeShippingThreshold || 29900;
  var ROUTES = CFG.routes || {
    cart: '/cart', cartAdd: '/cart/add.js',
    cartChange: '/cart/change.js', cartUpdate: '/cart/update.js'
  };

  /* ---------- Checkout CartPanda (direto, sem tela de "carregando") ----------
     A CartPanda não tem URL fixa de checkout: ela recebe o carrinho num POST e
     devolve a checkout_direct_url. Normalmente isso só roda na página /cart, que
     mostra o overlay "Carregando carrinho seguro". Aqui replicamos esse POST no
     próprio clique do botão e mandamos o cliente DIRETO pro checkout — sem passar
     pela /cart e sem tela de carregando.
     Se qualquer coisa falhar, cai no fluxo antigo (navega pra /cart, que também
     dispara a CartPanda) — o cliente nunca fica sem checkout. */
  var CP_ENDPOINT = (CFG.cartpanda && CFG.cartpanda.endpoint) || 'https://brooklyn-sneakers.mycartpanda.com/shopify/cart';
  var CP_SHOP = (CFG.cartpanda && CFG.cartpanda.shop) || 'ssex07-ua.myshopify.com';

  function cpUtmParam() {
    try {
      var terms = ['utm_source', 'utm_campaign', 'utm_term', 'utm_medium', 'utm_content', 'adclid', 'gclid', 'fbclid'];
      var p = new URLSearchParams(window.location.search);
      var out = '';
      terms.forEach(function (t) { if (p.has(t)) out += '&' + t + '=' + encodeURIComponent(p.get(t)); });
      return out;
    } catch (e) { return ''; }
  }

  function expressCheckout(btn) {
    var settled = false;
    var originalHtml = btn ? btn.innerHTML : '';
    if (btn) {
      btn.classList.add('is-loading');
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = 'Abrindo checkout…';
    }
    function fallback() {
      if (settled) return;
      settled = true;
      window.location.href = ROUTES.cart; // fallback: /cart dispara a CartPanda
    }
    var timer = setTimeout(fallback, 3500);

    getCart()
      .then(function (cart) {
        if (!cart || !cart.item_count) { throw new Error('empty'); }
        // Espelha o removeArrayKey da CartPanda (remove product_description)
        if (cart.items) cart.items.forEach(function (it) { delete it.product_description; });
        return fetch(CP_ENDPOINT, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ shop: CP_SHOP, host_name: window.location.host, cart_payload: cart })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (resp) {
        if (settled) return;
        if (resp && resp.active && resp.checkout_direct_url) {
          settled = true;
          clearTimeout(timer);
          var url = resp.checkout_direct_url + cpUtmParam();
          if (resp.remove_cart_item) {
            // CartPanda "move" o carrinho: limpa o da Shopify antes de redirecionar
            fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: '{}' })
              .then(function () { window.location.href = url; })
              .catch(function () { window.location.href = url; });
          } else {
            window.location.href = url;
          }
        } else {
          clearTimeout(timer);
          fallback();
        }
      })
      .catch(function () { clearTimeout(timer); fallback(); });
  }
  window.brooklynExpressCheckout = expressCheckout;

  /* ---------- DOM refs ---------- */
  var drawer   = document.querySelector('[data-cart-drawer]');
  var overlay  = document.querySelector('[data-cart-overlay]');
  var itemsEl  = document.querySelector('[data-cart-items]');
  var emptyEl  = document.querySelector('[data-cart-empty]');
  var footEl   = document.querySelector('[data-cart-foot]');
  var totalEl  = document.querySelector('[data-cart-total]');
  var comboEl  = document.querySelector('[data-cart-combo]');
  var comboMsg = document.querySelector('[data-combo-msg]');
  var comboFill = document.querySelector('[data-combo-fill]');
  var comboCta = document.querySelector('[data-combo-cta]');
  var barEl    = document.querySelector('[data-shipping-bar]');
  var barMsg   = document.querySelector('[data-shipping-msg]');
  var barFill  = document.querySelector('[data-shipping-fill]');
  var suggestEl  = document.querySelector('[data-cart-suggest]');
  var suggestRow = document.querySelector('[data-suggest-row]');
  var countEls = document.querySelectorAll('[data-cart-count]');

  var COMBO_GOAL = 2;                 // 2 pares fecham o combo
  var COMBO_PRICE = CFG.comboPrice || 'R$179,90';
  var suggestLoadedFor = null;        // evita recarregar sugestões à toa

  /* ---------- Money formatting (uses shop money_format) ---------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || 'R${{amount}}';
    var value = (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/g, value);
  }
  window.brooklynFormatMoney = formatMoney;

  /* ---------- Cart API ---------- */
  function getCart() {
    return fetch(ROUTES.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function changeQuantity(key, quantity) {
    setLoading(true);
    return fetch(ROUTES.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; })
      .catch(function () { showToast('Não deu pra atualizar. Tenta de novo.', true); })
      .finally(function () { setLoading(false); });
  }

  function updateCartUI() {
    return getCart().then(renderCart);
  }
  window.updateCartUI = updateCartUI;

  /* ---------- Drawer open/close ---------- */
  function openCartDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    drawer.focus();
  }
  function closeCartDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;

  function setLoading(on) {
    if (drawer) drawer.classList.toggle('is-loading', !!on);
  }

  /* ---------- Render ---------- */
  function renderCart(cart) {
    if (!cart) return;
    updateCount(cart.item_count);

    var hasItems = cart.item_count > 0;
    if (emptyEl) emptyEl.hidden = hasItems;
    if (footEl)  footEl.hidden  = !hasItems;
    if (itemsEl) itemsEl.style.display = hasItems ? '' : 'none';

    if (hasItems && itemsEl) {
      itemsEl.innerHTML = cart.items.map(renderItem).join('');
    } else if (itemsEl) {
      itemsEl.innerHTML = '';
    }

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);
    renderComboBar(cart.item_count);
    renderCombo(cart.item_count);
    renderSuggestions(cart);
  }

  /* ---------- Barra de progresso do combo (0 → 1 → 2 pares) ---------- */
  function renderComboBar(count) {
    if (!barEl) return;
    var pct = Math.min(100, (count / COMBO_GOAL) * 100);
    if (barFill) barFill.style.width = pct + '%';
    if (count >= COMBO_GOAL) {
      barEl.classList.add('is-complete');
      if (barMsg) barMsg.innerHTML = '✅ <strong>Combo formado!</strong> 2 pares por ' + COMBO_PRICE;
    } else if (count === 1) {
      barEl.classList.remove('is-complete');
      if (barMsg) barMsg.innerHTML = 'Falta só <strong>1 par</strong> pra pagar ' + COMBO_PRICE + ' nos 2 🔥';
    } else {
      barEl.classList.remove('is-complete');
      if (barMsg) barMsg.innerHTML = 'Adicione <strong>2 pares</strong> e pague ' + COMBO_PRICE;
    }
  }

  /* ---------- Combo nudge (CTA de apoio) ---------- */
  function renderCombo(count) {
    if (!comboEl) return;
    // Quando falta 1 par, as sugestões (abaixo) já cobrem o CTA principal.
    // Mantemos só a mensagem curta pra reforçar. Some quando o combo fecha.
    if (count !== 1) { comboEl.hidden = true; return; }
    comboEl.hidden = false;
    comboEl.classList.remove('is-done');
    if (comboMsg) comboMsg.innerHTML = '🔥 <strong>Quase lá!</strong> Escolha o 2º par abaixo';
    if (comboCta) comboCta.hidden = false;
  }

  /* ---------- Sugestões do 2º par (recomendações da Shopify) ---------- */
  function renderSuggestions(cart) {
    if (!suggestEl || !suggestRow) return;
    var count = cart.item_count;
    // Só mostra quando falta exatamente 1 par pro combo
    if (count !== COMBO_GOAL - 1 || !cart.items || !cart.items.length) {
      suggestEl.hidden = true;
      suggestLoadedFor = null;
      return;
    }
    var baseId = cart.items[0].product_id;
    if (suggestLoadedFor === baseId) { suggestEl.hidden = false; return; }
    suggestLoadedFor = baseId;

    var url = '/recommendations/products.json?product_id=' + baseId + '&limit=8&intent=related';
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data && data.products) ? data.products : [];
        // Não sugere o mesmo produto já no carrinho
        var inCart = {};
        cart.items.forEach(function (it) { inCart[it.product_id] = true; });
        products = products.filter(function (p) { return !inCart[p.id]; }).slice(0, 6);
        if (!products.length) { suggestEl.hidden = true; return; }
        suggestRow.innerHTML = products.map(suggestCard).join('');
        suggestEl.hidden = false;
      })
      .catch(function () { suggestEl.hidden = true; });
  }

  function suggestCard(p) {
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('//') === 0) img = 'https:' + img;
    var thumb = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_200x200$1$2') : '';
    var price = formatMoney(p.price);
    return '' +
      '<a class="bk-suggest-card" href="' + p.url + '">' +
        '<img class="bk-suggest-card__img" src="' + thumb + '" alt="' + escapeHtml(p.title) + '" width="96" height="96" loading="lazy">' +
        '<span class="bk-suggest-card__name">' + escapeHtml(p.title) + '</span>' +
        '<span class="bk-suggest-card__price">' + price + '</span>' +
        '<span class="bk-suggest-card__btn">Escolher →</span>' +
      '</a>';
  }

  function renderItem(item) {
    var img = item.image
      ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x120$1$2')
      : '';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="bk-cart-item__variant">Tam: ' + escapeHtml(item.variant_title) + '</p>'
      : '';
    return '' +
      '<div class="bk-cart-item" role="listitem">' +
        '<img class="bk-cart-item__img" src="' + img + '" alt="' + escapeHtml(item.product_title) + '" width="72" height="72" loading="lazy">' +
        '<div>' +
          '<p class="bk-cart-item__title">' + escapeHtml(item.product_title) + '</p>' +
          variant +
          '<p class="bk-cart-item__price">' + formatMoney(item.final_line_price) + '</p>' +
          '<div class="bk-qty">' +
            '<button type="button" aria-label="Diminuir" data-qty-down="' + item.key + '">−</button>' +
            '<input type="text" inputmode="numeric" value="' + item.quantity + '" data-qty-input="' + item.key + '" aria-label="Quantidade">' +
            '<button type="button" aria-label="Aumentar" data-qty-up="' + item.key + '">+</button>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="bk-cart-item__remove" data-qty-remove="' + item.key + '">Remover</button>' +
      '</div>';
  }

  function updateCount(count) {
    countEls.forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  /* ---------- Toast ---------- */
  var toastTimer;
  function showToast(msg, isError) {
    var t = document.createElement('div');
    t.className = 'bk-toast' + (isError ? ' bk-toast--error' : '');
    t.setAttribute('role', 'status');
    t.innerHTML = (isError ? '⚠ ' : '✓ ') + escapeHtml(msg);
    document.body.appendChild(t);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.remove(); }, 2600);
  }
  window.brooklynToast = showToast;

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- Event delegation ---------- */
  document.addEventListener('click', function (e) {
    var checkoutBtn = e.target.closest('[data-express-checkout]');
    if (checkoutBtn) { e.preventDefault(); expressCheckout(checkoutBtn); return; }

    var t = e.target.closest('[data-cart-open],[data-cart-close],[data-qty-up],[data-qty-down],[data-qty-remove]');
    if (!t) return;

    if (t.hasAttribute('data-cart-open'))  { e.preventDefault(); openCartDrawer(); updateCartUI(); return; }
    if (t.hasAttribute('data-cart-close')) { closeCartDrawer(); return; }

    var key;
    if ((key = t.getAttribute('data-qty-remove')) != null) { changeQuantity(key, 0); return; }
    if ((key = t.getAttribute('data-qty-up')) != null) {
      var inUp = itemsEl.querySelector('[data-qty-input="' + key + '"]');
      changeQuantity(key, parseInt(inUp.value, 10) + 1); return;
    }
    if ((key = t.getAttribute('data-qty-down')) != null) {
      var inDn = itemsEl.querySelector('[data-qty-input="' + key + '"]');
      changeQuantity(key, Math.max(0, parseInt(inDn.value, 10) - 1)); return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var key = input.getAttribute('data-qty-input');
    var q = Math.max(0, parseInt(input.value, 10) || 0);
    changeQuantity(key, q);
  });

  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCartDrawer();
  });

  /* ---------- Scroll reveal (fade-up) ---------- */
  function initReveals() {
    var els = document.querySelectorAll('.bk-reveal');
    if (!('IntersectionObserver' in window) || !els.length) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Init ---------- */
  function init() {
    updateCartUI();
    initReveals();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
